import { helpers } from 'vuelidate/lib/validators'
import axios from 'axios'
import axiosRetry from 'axios-retry'

axiosRetry(axios, { retries: 3,
    retryDelay: axiosRetry.exponentialDelay  });

export default fileType =>
  helpers.withParams(
    { type: 'fileType', fileType: fileType },
    function(value, parentVm) {
        if (!value) {
            return true
        } else {
            const types = ["application/pdf", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "image/png"];
            return types.includes(value.type);
        }
    }
  )